export const getObjectValues = obj => Object.keys(obj).map(key => obj[key]);



// WEBPACK FOOTER //
// ./src/components/Fullpage/utils/helpers.js